import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

/** Переключите на false, чтобы снова показать сайт. */
const MAINTENANCE_MODE = true;

const theme = createTheme({
  palette: {
    primary: {
      main: '#25A8E0', // Primary blue from the logo
    },
    secondary: {
      main: '#EA2227', // Red from the logo
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '3.5rem',
      '@media (max-width:900px)': {
        fontSize: '2.5rem',
      },
    },
    h2: {
      fontWeight: 600,
      fontSize: '2.5rem',
      '@media (max-width:900px)': {
        fontSize: '2rem',
      },
    },
    h3: {
      fontWeight: 600,
      fontSize: '2rem',
      '@media (max-width:900px)': {
        fontSize: '1.5rem',
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          padding: '10px 24px',
        },
        containedPrimary: {
          boxShadow: '0 4px 14px 0 rgba(37, 168, 224, 0.39)',
          '&:hover': {
            boxShadow: '0 6px 20px 0 rgba(37, 168, 224, 0.6)',
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

const maintenanceMessage =
  'Приносим извинения, сайт на временном техническом обслуживании';

root.render(
  <React.StrictMode>
    {MAINTENANCE_MODE ? (
      maintenanceMessage
    ) : (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    )}
  </React.StrictMode>
); 